// 游戏相关常量配置

/** 贴目（Komi）：白棋的补偿分数，用于平衡先手优势。在计算得分差时从黑棋得分中扣除 */
export const GAME_KOMI = 5.5

/** 最大步数限制，超过此步数强制结束游戏 */
export const GAME_END_FALLBACK_MAX_STEPS = 90

/** 游戏结束规则：某一方得分达到此值时强制结束游戏 */
export const GAME_END_SCORE_THRESHOLD = 45

/** 游戏结束规则：分差大于等于此值时强制结束游戏 */
export const GAME_END_SCORE_DIFF_THRESHOLD = 25

/** 游戏结束规则：连续回合分差大于等于此值时开始计数 */
export const GAME_END_CONSECUTIVE_DIFF_THRESHOLD = 20

/** 游戏结束规则：连续回合数达到此值时强制结束游戏 */
export const GAME_END_CONSECUTIVE_ROUNDS_THRESHOLD = 3
